import { ECurrency } from '../types/enums'

export const currencySymbols: Record<ECurrency, string> = {
  [ECurrency.TON]: '₮',
  [ECurrency.USDT]: '$',
  [ECurrency.USD]: '$',
  [ECurrency.EUR]: '€',
  [ECurrency.GBP]: '£',
  [ECurrency.JPY]: '¥',
  [ECurrency.CNY]: 'CN¥',
  [ECurrency.INR]: '₹',
  [ECurrency.BRL]: 'R$',
  [ECurrency.RUB]: '₽',
  [ECurrency.AED]: 'د.إ',
  [ECurrency.TOKEN]: '',
  [ECurrency.COIN]: '',
  [ECurrency.NONE]: '',
}
